/* topbar-lang.js — UX de los selectores de idioma con dropdown
   (<details data-lang-selector>): topbar desktop + footer del drawer móvil.
   <details> ya da el toggle nativo + accesibilidad; aquí solo añadimos:
     · cerrar al hacer click fuera del panel,
     · cerrar con Escape (y devolver foco al trigger).
   Cambiar de idioma es un submit del form 'localization' (POST + redirect),
   así que no hace falta cerrar manualmente en ese caso. */
(function () {
  function setup(d) {
    if (d._langInit) return;
    d._langInit = true;

    document.addEventListener('click', function (e) {
      if (d.open && !d.contains(e.target)) d.open = false;
    });

    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) {
        d.open = false;
        var summary = d.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  }

  function init() {
    var sels = document.querySelectorAll('[data-lang-selector]');
    for (var i = 0; i < sels.length; i++) setup(sels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El editor de tema recarga la sección al editarla.
  document.addEventListener('shopify:section:load', init);
})();
